export const getTokenAndRedirectF2 = async () => {
  try {
    const authUrl = `${process.env.REACT_APP_CORE_API_TOKEN}/auth`;

    const userString = localStorage.getItem('user');
    const userObject = userString ? JSON.parse(userString) : null;
    const userId = userObject ? userObject.username : null;
    const password = localStorage.getItem('ClientDocument');

    if (!userId) {
      throw new Error('User ID not found in localStorage');
    }

    const response = await fetch(authUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: userId.toString(),
        password,
        role: 'investor',
      }),
    });

    if (!response.ok) {
      throw new Error(`Authentication failed: ${response.statusText}`);
    }

    const data = await response.json();
    console.log('data->', token);
    const token = data.token || data.access_token || data.accessToken;

    if (!token) {
      throw new Error('Token not found in response');
    }
    const urlF2 = `${process.env.REACT_APP_LINK_FORM_F2}?token=${token}`;
    window.open(urlF2, '_blank');
  } catch (error) {
    console.error('Error getting token and redirecting:', error);
    alert(
      'Error al obtener el token de autenticación. Por favor intente nuevamente.',
    );
    throw error;
  }
};
